import { getAllPayrollsPageSlugs } from 'lib/contentful';
import { pageSettingsType } from 'types/pages/pageContainer.types';
import { storefrontPageType } from 'humanity/pages/storefrontPage/storefrontPage.types';
import StorefrontPage from 'humanity/pages/storefrontPage';
import { getStorefrontPageSSG } from 'humanity/pages/storefrontPage/storefrontPage.query';

const PayrollsPage = ({ pageSettings, pageContent }) => (
  <StorefrontPage pageSettings={pageSettings} pageContent={pageContent} />
);

PayrollsPage.propTypes = {
  pageSettings: pageSettingsType.isRequired,
  pageContent: storefrontPageType.isRequired,
};

export const getStaticProps = getStorefrontPageSSG('payrolls/');

export const getStaticPaths = async () => {
  const pages = await getAllPayrollsPageSlugs();

  const paths = pages.map((page) => ({
    // strip out 'payrolls/' to get the actual slug
    params: { slug: page.slug.replace('payrolls/', '') },
  }));

  return { paths, fallback: 'blocking' };
};

export default PayrollsPage;
